import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import {
	AbstractControl,
	FormArray,
	FormBuilder,
	FormGroup,
	Validators,
} from "@angular/forms";
import { ConfirmationService } from "primeng/api";
import { Table } from "primeng/table";
import { Utils } from "src/app/app.utils";
import { User } from "src/app/core/endpoints/models/user.model";
import { ApiService } from "src/app/core/services/api.service";
import { ToastService } from "src/app/core/services/toast.service";
import { confirmPassword } from "src/app/core/utils/utils";
import * as moment from "moment";
import "moment/locale/es";
import { ImageCropperComponent, ImageCroppedEvent, LoadedImage } from 'ngx-image-cropper';
import { Router } from "@angular/router";
import { UserLogs } from "src/app/core/endpoints/models/user-logs.model";

@Component({
	selector: "app-users-logs",
	templateUrl: "./users-logs.component.html",
	styleUrls: ["./users-logs.component.scss"],
})
export class UsersLogsComponent implements OnInit {
	@ViewChild("dt") table: Table;
	@ViewChild("filter") filter: ElementRef;

	public user: any;

	public usersLogs: UserLogs[] = [];
	public loading: boolean = false;
	public dialogUser: boolean = false;

	constructor(
		private apiService: ApiService,
		private fb: FormBuilder,
		private toast: ToastService,
		private confirmationService: ConfirmationService,
		public router: Router
	) {
	}

	ngOnInit(): void {
		this.loadUsersLogs();
	}

	public loadUsersLogs() {
		this.loading = true;
		this.apiService.getEntity("users-logs").subscribe({
			next: (result) => {
				this.usersLogs = result.usersLogs;
			},
			error: (err) => {
				this.loading = false;
			},
			complete: () => {
				this.loading = false;
			},
		});
	}

	public clear(table: Table) {
		table.clear();
		this.filter.nativeElement.value = "";
	}
}
